export type ModalTransaction = {
    status: string,
    res: string,
    msg: string
}

export type Transactions = {
    id: string,
    dateTime: string,
    name: string,
    value: number,
    direction: string
}

export type TransactionsHistoryList = {
    by_session: string,
    created_at: string,
    deleted_at: string,
    expired_at: string,
    id: string,
    is_npos: true,
    payee_currency: string,
    payer_amount: 0,
    payer_currency: string,
    payer_system: string,
    status: string,
    updated_at: string,
    user_id: string,
    payer: string,
  }

export const mockTransactions : Array<Transactions> = [
    {
        id: 'b2bd1972-4069-475d-a325-f44fb450bdb1',
        dateTime: '23/23/23 as 01:01:01',
        name: "Troca de BRL para USDT",
        value: 100.99,
        direction: 'out'
    },
    {
        id: 'b2bd1972-4069-475d-a325-f44fb450bdb1',
        dateTime: '23/23/23 as 01:01:01',
        name: "Troca de BRL para USDT",
        value: 100.99,
        direction: 'out'
    },
    {
        id: 'b2bd1972-4069-475d-a325-f44fb450bdb1',
        dateTime: '23/23/23 as 01:01:01',
        name: "Troca de BRL para USDT",
        value: 100.99,
        direction: 'out'
    },
    {
        id: 'b2bd1972-4069-475d-a325-f44fb450bdb1',
        dateTime: '23/23/23 as 01:01:01',
        name: "Troca de BRL para USDT",
        value: 100.99,
        direction: 'out'
    },
]

export type PaymentCreation = {
    amount: number,
    pair: string,
    pay_method: string,
    quote_amount: number
}

export type RequestInfo = {
    type : string,
    url : string,
    payload: string,
    refreshToken: string
}

export type WithdrawalPayload = {
    pair: string
}

export type TransferAccount = {
    code: number,
    data: {
        by_session: string,
        charge_id: string,
        created_at: string,
        expired_at: string,
        id: string,
        is_npos: boolean,
        payee_currency: string,
        payer: string,
        payer_amount: number,
        payer_currency: string,
        payer_system: string,
        status: string,
        updated_at: string,
        user_id: string,
        type:string
    }  
}

export type WithdrawalResponse = {
    code: number,
    data: {
        amount: number,
        currency: string,
        id: string
    }      
}

export type makeWithdrawalResponse = {
    code:number,
    data:{
        created_at:Date,
        updated_at:Date,
        expired_at:Date,
        id:string,
        order_type:string,
        user_id:string,
        pair:string,
        system_currency:string,
        payee:string,
        status:string,
        price:number,
        activity_id:string,
        amount:number,
    }
}

export type withdrawalReceipt = {
    code:number,
    data:{
        created_at: Date,
        updated_at: Date,
        delivered_at: Date,
        id: string,
        system_currency: string,
        currency: string,
        status: string,
        payee: string,
        amount: number
    }
}

export const Transactionlabel = (s:any, charge?: boolean) => {
    if (s === 'charge') return "Pagamento"
    if (s === 'withdrawal') return "Pedido de Envio"
    if (s === 'waiting-delivery') return "Processo de envio"
    if (s === 'waiting-offer') return "Processo de troca"
    if (s === 'waiting-withdrawal') return "Esperando retirada"
    if (s === 'pending') return "Esperando usuário"
    if (s === 'expired') {
        if (charge) return "Cobrança Expirada"
        else return "Expirado"
    } 
    if (s === 'done') {
        if (charge) return "Cobrança Efetuada"
        else return "Enviado"
    }
    return "not labbeled";
} 

export const statusToActivities = (x:any) => {
    if (x.event.status === 'done') {
        if(x.activity === 'withdrawal') return "finalizado"
        if(x.activity === 'charge') return "confirmado"
    }
    if (x.event.status === 'pending') return "em processo"
    if (x.event.status === 'waiting-offer') return "em processo"
    if (x.event.status === 'delivering') return "processo de entrega"
    if (x.event.status === 'expired') return "expirado"
    return "not labbeled";
} 